import React, { PropsWithChildren } from 'react';

export function PagePublicationInfoText(props: PropsWithChildren) {
  return <div className="page-publication-info__text">{props.children}</div>;
}
